import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  gap: 1rem;

  & > * {
    flex: 1;
  }
`;
